import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    breadcrumb: {
        display: "flex",
        fontSize: 12,
        marginBottom: theme.spacing(2),
        color: 'rgb(146, 146, 146)',
    },
    breadcrumbLink: {
        color: 'rgb(146, 146, 146)',
        textDecoration: 'none',
    },
    breadcrumbSeparator: {
        minHeight: 12,
        margin: theme.spacing(0, 1),
    }
}));

